define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PermitLicItem = void 0;
    class PermitLicItem extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "PermitId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LicenseItemId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LicenseItemIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ItemType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ItemTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Permit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, PermitLicItem.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Permit = parent;
            this.PermitId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Permit = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.PermitId = (0, EntityUtil_1.toInt)(entity.PermitId);
            a.LicenseItemId = (0, EntityUtil_1.toInt)(entity.LicenseItemId);
            a.ItemType = (0, EntityUtil_1.toInt)(entity.ItemType);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, PermitLicItem.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                PermitId: this.PermitId,
                LicenseItemId: this.LicenseItemId,
                ItemType: this.ItemType,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.PermitLicItem = PermitLicItem;
    Object.defineProperty(PermitLicItem, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "PermitLicItem"
    });
    Object.defineProperty(PermitLicItem, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Permit License Items"
    });
    Object.defineProperty(PermitLicItem, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "PermitId", "LicenseItemId", "ItemType"]
    });
    Object.defineProperty(PermitLicItem, "PermitIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitLicItem, "LicenseItemIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitLicItem, "ItemTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PermitLicItem, "ItemTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItem.prototype, "PermitId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItem.prototype, "PermitIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItem.prototype, "LicenseItemId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItem.prototype, "LicenseItemIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItem.prototype, "ItemType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItem.prototype, "ItemTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItem.prototype, "Permit", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicItem.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicItem.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicItem.prototype, "merge", null);
});
